import React, {FC} from 'react';
import './style.scss';
import classNames from 'classnames';

interface INavBarItem {
    onClick: () => any,
    children: string,
    icon: string,
    activeIcon: string,
    activePage?: string,
    currentPage: string
}

const NavBarItem: FC<INavBarItem> = ({
                                         onClick,
                                         children,
                                         icon,
                                         currentPage,
                                         activeIcon,
                                         activePage
                                     }) => {
    const isActivePage: boolean = activePage === currentPage;
    return (
        <div
            className={classNames({
                "navbar__item": true,
                "navbar__item--active": isActivePage
            })}
            onClick={onClick}
        >
            <div className="container">
                <img
                    className="navbar__item-image"
                    src={isActivePage ? activeIcon : icon}
                    alt="Icon"
                />
            </div>
            <div className="navbar__item-text">
                {children}
            </div>
        </div>
    )
};

export default NavBarItem;
